import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { CloseButton, ModalContent, ModalHeader, ModalOverflow, ModalTitle } from './SizeGuide.css';
import { getDefaultSizeGuideTabId } from '../../helpers';
import SizeGuideByDepartment from './SizeGuideByDepartment/SizeGuideByDepartment';
import { SizeGuideDepartmentSwitch } from './';
import Departments from '../../common/models/Departments';
import { Desktop, Mobile } from '../MediaQuery';
import {
  CloseImg,
  ModalHeaderBody,
  ModalHeaderTitle,
  ModalHeaderWrapper
} from '../../components_mobile/components/SizeGuide/SizeGuide.css';
import { Column, Row } from 'hedron';
import HorizontalDivider from '../../components_mobile/components/HorizontalDivider';
import SizeGuideHeader from './SizeGuideHeader';

class SizeGuide extends Component {
  constructor(props) {
    super(props);

    const { department } = props;
    this.state = { department };
    this.switchDepartment = this.switchDepartment.bind(this);
  }

  switchDepartment() {
    const { department } = this.state;
    const otherDepartment = Departments.getOppositeDepartment(department);
    this.setState({ department: otherDepartment });
  }

  renderCommon() {
    const { department } = this.state;
    const { categoryTree, currentCategoryId } = this.props;

    const tabs = getDefaultSizeGuideTabId(categoryTree, currentCategoryId);
    const defaultTab = tabs[tabs.length - 1];
    return <SizeGuideByDepartment department={department} defaultTab={defaultTab} />;
  }

  renderMobileHeader() {
    const { s3BasePath, closeSizeGuide } = this.props;
    const { department } = this.state;

    return (
      <div>
        <ModalHeaderWrapper data-cy="header-size-guide">
          <Row>
            <Column fluid xs={11}>
              <ModalHeaderTitle data-cy="title-size-guide">
                <SizeGuideHeader department={department} />
                <SizeGuideDepartmentSwitch department={department} onClick={this.switchDepartment} />
              </ModalHeaderTitle>
            </Column>
            <Column fluid xs={1} style={{ textAlign: 'right' }}>
              <CloseImg data-cy="close-size-guide" onClick={closeSizeGuide} src={`${s3BasePath}mkt/icon/x_black.png`} />
            </Column>
          </Row>
          <ModalHeaderBody>
            Please note that this is a representative guide only. Sizes and measurements may vary depending on the style
            of the item and how the brand fits. If you are not sure about a size or a fit, we recommend to try the
            product at a nearby luxury boutique.
          </ModalHeaderBody>
        </ModalHeaderWrapper>
        <HorizontalDivider padding="0 5%" />
      </div>
    );
  }

  render() {
    const { department } = this.state;
    const { closeSizeGuide } = this.props;

    return (
      <Fragment>
        <Mobile>
          {this.renderMobileHeader()}
          {this.renderCommon()}
        </Mobile>

        <Desktop>
          <ModalContent data-cy="size-guide">
            <ModalHeader>
              <ModalTitle data-cy="title-size-guide">
                <SizeGuideHeader department={department} />
              </ModalTitle>
              <SizeGuideDepartmentSwitch department={department} onClick={this.switchDepartment} />
              <CloseButton data-cy="close-size-guide" onClick={closeSizeGuide}>
                x
              </CloseButton>
            </ModalHeader>
            {this.renderCommon()}
          </ModalContent>
          <ModalOverflow onClick={closeSizeGuide} />
        </Desktop>
      </Fragment>
    );
  }
}

SizeGuide.propTypes = {
  categoryTree: PropTypes.arrayOf(PropTypes.object),
  currentCategoryId: PropTypes.string,
  closeSizeGuide: PropTypes.func.isRequired,
  department: PropTypes.string.isRequired
};

export default SizeGuide;
